export default __webpack_public_path__ + "app/images/theme-images/light/screenshot-btn/icon-20-screenshot@2x.webp";